import { combineReducers } from 'redux'
import socket from './socket'
import match from './match'
import theme from './theme'

export default combineReducers({
  socket,
  match,
  theme,
})
